export const DisabledState = {
  NeedHelp: "Need help?",
  HavingTrouble: "If you're having trouble with the process,",
  ContactSupport: "Contact Support.",
  HappyToAssist: "We're happy to assist!"
}
